import { REMINDER_WIZARD_STEPS } from '../utils';

export function ReminderWizardSteps({ currentStep }) {
  return (
    <div className="flex items-center gap-2 mt-2">
      {REMINDER_WIZARD_STEPS.map((label, index) => {
        const done = index < currentStep;
        const active = index === currentStep;
        return (
          <div key={label} className="flex items-center gap-2 min-w-0">
            <span
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${
                done || active
                  ? 'bg-primary text-white'
                  : 'bg-form-background-light text-text-muted'
              }`}
            >
              {index + 1}
            </span>
            <span
              className={`hidden sm:inline text-sm font-medium truncate ${
                active ? 'text-text-primary' : 'text-text-muted'
              }`}
            >
              {label}
            </span>
            {index < REMINDER_WIZARD_STEPS.length - 1 && (
              <span className="hidden sm:block w-6 h-px bg-border-default shrink-0" />
            )}
          </div>
        );
      })}
    </div>
  );
}
